const ServiceScalarFields = [
	'name',
	'id',
	'createdAt',
	'description',
	'updatedAt',
];

export { ServiceScalarFields };
